<template>
<div class="page_ table_textc">
    <div>
        <a-form layout="inline">
            <a-form-item label="保单号 " >
                <a-input class="min_input_" style="width: 200px;" v-model="policyNoi" placeholder="请输入保单号"></a-input>
            </a-form-item>
            <a-form-item label="投保日期">
                <a-range-picker :placeholder="['请选择日期', '请选择日期']" style="width: 215px;" @change="rangeDate" :value="createValue"></a-range-picker>
            </a-form-item>
            <a-form-item label="投保人">
                <a-input class="min_input_" v-model="holderNamei"></a-input>
            </a-form-item>
            <a-form-item label="被保人">
                <a-input class="min_input_" v-model="insuredNamei"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="searchData()">查询</a-button>
                <a-button style="margin-left: 8px;" type="default" @click="initData()">重置</a-button>
            </a-form-item>
        </a-form>
    </div>
    <a-table 
        style="margin-top: 17px;" 
        :columns="columns" 
        :dataSource="tableData"
        :pagination="pagination"
        @change="handlePageChange"
        class="table_b table_nowrap"
    >
       <span slot="operation" slot-scope="text, record" class="span_btn">
            <a @click="correct(record.policyId)">批改</a>
        </span>
    </a-table>
    <div class="fixbg_"  v-if="showCorrect" @click="closeFix()">
        <div class="fixcon" @click.stop>
            <p>保单批改</p>
            <span class="close_" @click.stop="closeFix()"></span>
            <div class="detail">
               <p>投保人信息</p>
               <div class="forminfo_">
                    <div class="infoitem">
                        <span>姓名:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicyHolder.name" readonly />
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>证件号码:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicyHolder.idNumber" readonly />
                        </div>
                    </div>
                   <div class="infoitem" v-if='salPolicyHolder.gender'>
                        <span>性别:</span>
                        <div class="itemright">
                            <select v-model="salPolicyHolder.gender" placeholder="请选择性别">
                            <option v-for="item1 in sexOptions" :value="item1.value">{{item1.name}}</option>
                            </select>
                            <span class="selectmask" v-if="salPolicyHolder.idType==='1'||salPolicyHolder.idType==='01'"></span>
                        </div>
                    </div>
                    <div class="infoitem" v-if="salPolicyHolder.birthDate">
                        <span>出生日期：</span>
                        <div class="itemright datei_">
                            <a-date-picker @change="onChange1" v-if="salPolicyHolder.birthDate&&salPolicyHolder.birthDate!=''" :defaultValue="moment(salPolicyHolder.birthDate.indexOf('-')===-1?salPolicyHolder.birthDate.substring(0,4)+'-'+salPolicyHolder.birthDate.substring(4,6)+'-'+salPolicyHolder.birthDate.substring(6,8):salPolicyHolder.birthDate,dateFormat)"  :format="dateFormat" :showToday='false' :allowClear='false' placeholder="请选择日期"/>
                            <a-date-picker @change="onChange1" v-else  :showToday='false' :allowClear='false' placeholder="请选择日期"/>
                            <span class="selectmask" v-if="salPolicyHolder.idType==='1'||salPolicyHolder.idType==='01'"></span>
                        </div>
                    </div>
               </div>
               <p>被保人信息</p>
               <div class="forminfo_" v-for="(item,index) in salInsuredList" :key="'pinfo'+index" :class="'pinfo'+index">
                   <div class="infoitem">
                        <span>姓名:</span>
                        <div class="itemright">
                        <input type="text" v-model="item.name" />
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>证件类型:</span>
                        <div class="itemright">
                        <select v-model="item.idType">
                            <option v-for="item1 in idTypeOptions" :value="item1.value">{{item1.name}}</option>
                        </select>
                        <i class="downicon"></i>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>证件号码:</span>
                        <div class="itemright">
                        <input type="text" v-model="item.idNumber" @blur="textIdNumber(item.idType,item.idNumber,index)"/>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>性别:</span>
                        <div class="itemright">
                            <select v-model="item.gender">
                            <option v-for="item1 in sexOptions" :value="item1.value">{{item1.name}}</option>
                            </select>
                            <span class="selectmask" v-if="item.idType==='1'||item.idType==='01'"></span>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>出生日期：</span>
                        <div class="itemright datei_">
                            <a-date-picker @change="onChange" :defaultValue="moment(item.birthDate.indexOf('-')===-1?item.birthDate.substring(0,4)+'-'+item.birthDate.substring(4,6)+'-'+item.birthDate.substring(6,8):item.birthDate,dateFormat)" :value="moment(item.birthDate.indexOf('-')===-1?item.birthDate.substring(0,4)+'-'+item.birthDate.substring(4,6)+'-'+item.birthDate.substring(6,8):item.birthDate,dateFormat)" :format="dateFormat" :showToday='false' :allowClear='false' v-if="item.idType==='1'||item.idType==='01'" placeholder="请选择日期"/>
                            <a-date-picker @change="(date, dateString)=>onChange(date, dateString,index)" :defaultValue="moment(item.birthDate.indexOf('-')===-1?item.birthDate.substring(0,4)+'-'+item.birthDate.substring(4,6)+'-'+item.birthDate.substring(6,8):item.birthDate,dateFormat)" :format="dateFormat" :showToday='false' :allowClear='false' placeholder="请选择日期" v-else/>
                            <span class="selectmask" v-if="item.idType==='1'||item.idType==='01'"></span>
                        </div>
                    </div>
               </div>
               <div class="forminfo_ cor_date">
                   <div class="infoitem">
                        <span>批改日期：</span>
                        <div class="itemright datei_">
                            <a-date-picker @change="onChangeS" :defaultValue="moment(defaultDate,dateFormat)" :format="dateFormat" :disabledDate="disabledDate" :showToday='false' :allowClear='false'/>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>起保日期:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicy.effectiveDate.substring(0,10)" readonly/>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>终保日期:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicy.expireDate.substring(0,10)" readonly/>
                        </div>
                    </div>
               </div>
               
            </div>
             <div class="btn_b">
                <button @click="goNext(0)">投保人批改</button>
                <button @click="goNext(1)">被保人批改</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
import api from '@/utils/api'
const columns = [{
    title: '保单号',
    key: 'policyNo',
    dataIndex: 'policyNo'
}, {
    title: '产品名称',
    key: 'productName',
    dataIndex: 'productName'
}, {
    title: '保费',
    key: 'price',
    dataIndex: 'price'
}, {
    title: '投保人',
    key: 'holderName',
    dataIndex: 'holderName'
}, {
    title: '起保日期',
    key: 'startDate',
    dataIndex: 'startDate'
}, {
    title: '终保日期',
    key: 'endDate',
    dataIndex: 'endDate'
}, {
    title: '操作',
    key: 'do',
    scopedSlots: { customRender: "operation" }
},]

export default {
    data () {
        document.title = '保单批改'
        return {
            columns,
            tableData: [],
            pagination: {
                total:0,
                pageSize: 20,
                pageNum: 1
            },
            createValue:[],
            policyNo:'',
            status:1,
            pageNum:'1',
            pageSize:'20',
            policyNoi:'',
            startDatei:'',
            endDatei:'',
            holderNamei:'',
            insuredNamei:'',
            showCorrect:false,
            dateFormat: 'YYYY-MM-DD',
            step:1,
            salInsuredList: [],
            salPolicy: {},
            salPolicyHolder: {},
            idTypeOptions: [
                {
                name: "身份证",
                value: "1"
                },
                {
                name: "护照",
                value: "2"
                },
                {
                name: "台湾通行证",
                value: "6"
                },
                {
                name: "港澳通行证",
                value: "4"
                }
            ],
            sexOptions: [
                {
                value:"M",
                name:"男"
                },
                {
                value:"F",
                name:"女"
                }
            ],
            policyId:'',
            defaultDate:''
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        moment,
        handlePageChange (e) {
            this.pageNum=e.current
            this.initData()
        },
        initData(){
            this.policyNoi=''
            this.createValue=[]
            this.startDatei=''
            this.endDatei=''
            this.holderNamei=''
            this.insuredNamei=''
            let queryData={pageNum:this.pageNum,pageSize:this.pageSize,status:this.status}
            this.queryData(queryData) 
        },
        queryData(queryData){
            api.findUserPolicy(queryData).then(res => {
                if(res.data.returnCode==='0000'||res.data.content!=null){
                    this.tableData=res.data.content.map((item,index)=>{
                        item.key=index
                        return item
                    })
                    this.pagination.total=res.data.totalCount
                }
            })
        },
        searchData(){
           let queryData={pageNum:this.pageNum,pageSize:this.pageSize,status:this.status,policyNo:this.policyNoi,startDate:this.startDatei,endDate:this.endDatei,holderName:this.holderNamei,insuredName:this.insuredNamei}
           this.queryData(queryData) 
        },
        rangeDate(dates,dateStrings) {
           this.createValue=dates
           this.startDatei=dateStrings[0]
           this.endDatei=dateStrings[1]
        },
        correct(policyId){
            console.log(policyId,'policyId')
            this.policyId=policyId
            this.showCorrect=true
            api.queryPolicyDetail(policyId).then(res => {
                if(res.data.returnCode==='0000'||res.data.content!=null){
                    this.salInsuredList=res.data.content.salInsuredList
                    this.salPolicyHolder=res.data.content.salPolicyHolder
                    this.salPolicy=res.data.content.salPolicy
                    this.defaultDate=moment(res.data.content.salPolicy.effectiveDate.slice(0,10)).add(1, 'days').format('YYYY-MM-DD')
                }
            })
            this.defaultDate=moment(this.salPolicy.effectiveDate.slice(0,10)).add(1, 'days').format('YYYY-MM-DD')
        },
         // 身份证正则校验
        textIdNumber(type,num,index){
            console.log(type,num,index,"num")
            let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if(type==='1'||type==='01'){
                if(idcardReg.test(num)) {
                    this.salInsuredList[index].birthDate=num.substr(6, 4)+'-'+num.substr(10, 2)+'-'+num.substr(12, 2);
                    this.salInsuredList[index].gender = num.substring(16, 17)%2===0?'F':'M'
                }else{
                    this.$notification.open({
                        message: '操作提醒',
                        description:
                        '不合法的证件号码，请重新输入',
                        duration: 2,
                    });
                }
            }
        },
        onChange(date, dateString,index) {
           this.salInsuredList[index].birthDate= dateString
        },
        onChange1(date, dateString) {
           this.salPolicyHolder.birthDate= dateString
        },
        onChangeS(date, dateString) {
           this.defaultDate=dateString
        },
        closeFix(){
            this.showCorrect=false
        },
        goNext(index){
            let newdata={}
            if(index===0){
                 newdata={salPolicyHolder:this.salPolicyHolder,salPolicy:this.salPolicy,issueDateStr:this.defaultDate}
            }else{
                newdata={salInsuredList:this.salInsuredList,salPolicyHolder:this.salPolicyHolder,salPolicy:this.salPolicy,issueDateStr:this.defaultDate}
            }
            console.log(newdata,'newdata----')
            api.correctPolicy(newdata).then(res => {
                if(res.data.returnCode==='0000'){
                    this.$notification.open({
                        message: '操作提醒',
                        description:
                        '批改成功',
                        duration: 2,
                    });
                    location.reload()
                }
            })
        },
        disabledDate(currentDate){
            return currentDate&&(currentDate>moment(this.salPolicy.expireDate.slice(0,10))||currentDate<moment(this.salPolicy.effectiveDate.slice(0,10)).add(1, 'days'))
        }
    }
}
</script>
<style lang="scss" scoped>
.min_input_ {
    width: 64px;
}
.span_btn{
    a{
        color:#FF4C1C;
        margin-right:8px;
        &:last-child{
            margin-right:0;
        }
    }
}
    .fixbg_{
        position:fixed;
        top:0;
        right:0;
        bottom:0;
        left:0;
        z-index:5;
        background-color:rgba(0,0,0,0.3);
        height:100vh;
        .fixcon{
            background-color:#fff;
            position:absolute;
            top:0;
            right:0;
            left:0;
            bottom:0;
            width:960px;
            margin:0 auto;
            max-height:50vh;
            overflow-y:hidden;
            padding-top:50px;
            top:50%;
            transform: translateY(-50%);
            &>p{
                font-weight:bold;
                font-size:16px;
                height:50px;
                line-height:50px;
                margin:0;
                position:absolute;
                left:0;
                top:0;
                right:0;
                margin:0 auto;
                padding:0 20px;
            }
            .close_{
                width:30px;
                height:30px;
                background:url(../../../assets/wxmall/closeicon.png) center center no-repeat;
                background-size:30px 30px;
                position:absolute;
                right:20px;
                top:10px;
                cursor:pointer;
            }
            .detail{
                position:absolute;
                left:0;
                right:0;
                padding:0 20px;
                bottom:50px;
                top:50px;
                overflow-y: scroll;
                &>p{
                    font-weight:bold
                }
            }
            .forminfo_{
                display:flex;
                flex-direction:row;
                .infoitem{
                    display:flex;
                    flex:1;
                    margin-bottom:20px;
                    input{
                        border:1px solid #d9d9d9;
                        background-color:transparent;
                        width:95px;
                        padding-left:5px;
                        height:32px;
                        line-height:32px;
                        border-radius:4px;
                    }
                    select{
                        width:100px;
                        height:32px;
                        line-height:32px;
                        border-radius:4px;
                        border:1px solid #d9d9d9;
                    }
                    span{
                        white-space: nowrap;
                        margin-right:5px;
                        width:65px;
                        text-align:left;
                        height:30px;
                        line-height:30px;
                    }
                }
            }
            .btn_b{
            width:100%;
            position:absolute;
            bottom:0;
            left:0;
            right:0;
            height: 50px;
            padding-bottom: 10px;
            display: flex;
            justify-content: center;
            button{
                width:100px;
                height:40px;
                line-height:40px;
                background-color:#ff4c1c;
                color:#fff;
                text-align:center;
                border:none;
                outline:none;
                border-radius:4px;
                display:block;
                font-size:16px;
                padding:0;
                cursor:pointer;
                &:last-child{
                    margin-left:40px;
                }
            }
        }
        }
    }
    .itemright{
        position:relative;
    }
    .selectmask{
        position:absolute;
        top:0;
        bottom:0;
        z-index:5;
        left:0;
        right:0;
        background-color:transparent;
        width:100%!important;
    }
    .table_b{
        border:1px solid rgba(0,0,0,0.1);
    }
</style>